// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Organization_container__T3hU3{
    display: flex;
    min-height: calc(100vh - 230px);
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.Organization_fundraisers__-LNog{
    width: 100%;
    padding-left: 35px;
    padding-right: 35px;
}
@media(max-width: 1320px){
    .Organization_fundraisers__-LNog{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .Organization_fundraisers__-LNog{
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Organization_topSection__fFJpy{
    display: flex;
    align-items: baseline;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}
@media(max-width: 1000px){
    .Organization_topSection__fFJpy{
        flex-wrap: wrap;
    }
}
.Organization_organizationContainer__7xEhE{
    display: flex;
    align-items: center;
}
.Organization_organizationPicture__s1kem{
    height: 60px;
    width: 60px;
    margin-right: 10px;
    border-radius: 500px;
}
@media(max-width: 600px){
    .Organization_organizationPicture__s1kem{
        height: 50px;
        width: 50px;
    }
}
.Organization_organizationName__ZV23u{
    margin-right: 40px;
    text-align: left;
    word-break: normal;
}
.Organization_bottomSection__oqA20{
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
}
@media(max-width: 1400px){
    .Organization_bottomSection__oqA20{
        justify-content: center;
    }
}
.Organization_fundraiser__83ize{
    margin-bottom: 35px;
}
.Organization_fundraiser__83ize:not(:last-of-type){
    margin-right: 30px;
}
@media(max-width: 1400px){
    .Organization_fundraiser__83ize{
        width: calc(50% - 66px) !important;
    }
    .Organization_fundraiser__83ize:nth-of-type(even){
        margin-right: 0;
    }
}
@media(max-width: 1320px){
    .Organization_fundraiser__83ize{
        width: calc(33% - 68px) !important;
    }
    .Organization_fundraiser__83ize:nth-of-type(even){
        margin-right: 30px;
    }
    .Organization_fundraiser__83ize:nth-of-type(3n), .Organization_fundraiser__83ize:last-of-type{
        margin-right: 0;
    }
}
@media(max-width: 1200px){
    .Organization_fundraiser__83ize{
        width: calc(50% - 66px) !important;
    }
    .Organization_fundraiser__83ize:nth-of-type(even){
        margin-right: 0;
    }
    .Organization_fundraiser__83ize:nth-of-type(3n){
        margin-right: auto;
    }
}
@media(max-width: 820px){
    .Organization_fundraiser__83ize{
        width: calc(100% - 48px) !important;
        margin-bottom: 25px;
        margin-right: 0 !important;
    }
}
.Organization_rightSide__YJJSs{
    display: flex;
    position: relative;
    top: -8px;
    margin-left: auto;
}
@media(max-width: 600px){
    .Organization_rightSide__YJJSs{
        margin-top: 10px;
    }
}
.Organization_searchInput__N9KP9{
    margin-right: 20px;
}
@media(max-width: 1000px){
    .Organization_rightSide__YJJSs{
        width: 100%;
    }
    .Organization_searchInput__N9KP9{
        width: calc(100% - 150px);
    }
    .Organization_searchInput__N9KP9 > div{
        width: 100%;
    }
    .Organization_searchInput__N9KP9 input{
        width: calc(100% - 75px);
    }
}
.Organization_searchOrder__x5lad{
    margin-left: auto;
}
.Organization_noFundraisers__qDaQt{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 50px;
}
.Organization_magnifyingGlassWithQuestionMark__EVsbK{
    height: 60px;
    width: 60px;
}
.Organization_noFundraisersDescription__QN5\\+T{
    margin-top: 35px;
    color: #1F363D;
    text-align: center;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.Organization_noFundraisersButton__3\\+-2m{
    width: 150px;
    margin-top: 50px;
    margin-bottom: 30px;
    padding: 4px 20px;
    color: #FFFFFF;
    background-color: #40798C;
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Organization.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,mCAAmC;QACnC,mBAAmB;QACnB,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;IACf;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".container{\n    display: flex;\n    min-height: calc(100vh - 230px);\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.fundraisers{\n    width: 100%;\n    padding-left: 35px;\n    padding-right: 35px;\n}\n@media(max-width: 1320px){\n    .fundraisers{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .fundraisers{\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.topSection{\n    display: flex;\n    align-items: baseline;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n}\n@media(max-width: 1000px){\n    .topSection{\n        flex-wrap: wrap;\n    }\n}\n.organizationContainer{\n    display: flex;\n    align-items: center;\n}\n.organizationPicture{\n    height: 60px;\n    width: 60px;\n    margin-right: 10px;\n    border-radius: 500px;\n}\n@media(max-width: 600px){\n    .organizationPicture{\n        height: 50px;\n        width: 50px;\n    }\n}\n.organizationName{\n    margin-right: 40px;\n    text-align: left;\n    word-break: normal;\n}\n.bottomSection{\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 20px;\n}\n@media(max-width: 1400px){\n    .bottomSection{\n        justify-content: center;\n    }\n}\n.fundraiser{\n    margin-bottom: 35px;\n}\n.fundraiser:not(:last-of-type){\n    margin-right: 30px;\n}\n@media(max-width: 1400px){\n    .fundraiser{\n        width: calc(50% - 66px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 0;\n    }\n}\n@media(max-width: 1320px){\n    .fundraiser{\n        width: calc(33% - 68px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 30px;\n    }\n    .fundraiser:nth-of-type(3n), .fundraiser:last-of-type{\n        margin-right: 0;\n    }\n}\n@media(max-width: 1200px){\n    .fundraiser{\n        width: calc(50% - 66px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 0;\n    }\n    .fundraiser:nth-of-type(3n){\n        margin-right: auto;\n    }\n}\n@media(max-width: 820px){\n    .fundraiser{\n        width: calc(100% - 48px) !important;\n        margin-bottom: 25px;\n        margin-right: 0 !important;\n    }\n}\n.rightSide{\n    display: flex;\n    position: relative;\n    top: -8px;\n    margin-left: auto;\n}\n@media(max-width: 600px){\n    .rightSide{\n        margin-top: 10px;\n    }\n}\n.searchInput{\n    margin-right: 20px;\n}\n@media(max-width: 1000px){\n    .rightSide{\n        width: 100%;\n    }\n    .searchInput{\n        width: calc(100% - 150px);\n    }\n    .searchInput > div{\n        width: 100%;\n    }\n    .searchInput input{\n        width: calc(100% - 75px);\n    }\n}\n.searchOrder{\n    margin-left: auto;\n}\n.noFundraisers{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 50px;\n}\n.magnifyingGlassWithQuestionMark{\n    height: 60px;\n    width: 60px;\n}\n.noFundraisersDescription{\n    margin-top: 35px;\n    color: #1F363D;\n    text-align: center;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.noFundraisersButton{\n    width: 150px;\n    margin-top: 50px;\n    margin-bottom: 30px;\n    padding: 4px 20px;\n    color: #FFFFFF;\n    background-color: #40798C;\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Organization_container__T3hU3`,
	"fundraisers": `Organization_fundraisers__-LNog`,
	"topSection": `Organization_topSection__fFJpy`,
	"organizationContainer": `Organization_organizationContainer__7xEhE`,
	"organizationPicture": `Organization_organizationPicture__s1kem`,
	"organizationName": `Organization_organizationName__ZV23u`,
	"bottomSection": `Organization_bottomSection__oqA20`,
	"fundraiser": `Organization_fundraiser__83ize`,
	"rightSide": `Organization_rightSide__YJJSs`,
	"searchInput": `Organization_searchInput__N9KP9`,
	"searchOrder": `Organization_searchOrder__x5lad`,
	"noFundraisers": `Organization_noFundraisers__qDaQt`,
	"magnifyingGlassWithQuestionMark": `Organization_magnifyingGlassWithQuestionMark__EVsbK`,
	"noFundraisersDescription": `Organization_noFundraisersDescription__QN5+T`,
	"noFundraisersButton": `Organization_noFundraisersButton__3+-2m`
};
export default ___CSS_LOADER_EXPORT___;
